import React from 'react'

const GiftRoundIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="42" height="42" viewBox="0 0 60 60" {...props}>
    <circle cx="30" cy="30" r="30" fill="#DA291C" />

    <g
      clipPath="url(#clip0)"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none">
      <path d="M38.25 25.5h-16.5c-.414 0-.75.336-.75.75v3c0 .414.336.75.75.75h16.5c.414 0 .75-.336.75-.75v-3c0-.414-.336-.75-.75-.75Z" />
      <path d="M37.5 30v6.75c0 .199-.079.39-.22.53a.75.75 0 0 1-.53.22h-13.5a.75.75 0 0 1-.53-.22.75.75 0 0 1-.22-.53V30" />
      <path d="M30 25.5v12" />
      <path d="M34.574 20.926c.876.876.927 2.35 0 3.171C32.989 25.5 30 25.5 30 25.5s0-2.988 1.406-4.574c.819-.927 2.293-.875 3.168 0Z" />
      <path d="M25.426 20.926c-.876.876-.928 2.35 0 3.171C27.011 25.5 30 25.5 30 25.5s0-2.988-1.406-4.574c-.819-.927-2.293-.875-3.168 0Z" />
    </g>

    <defs>
      <clipPath id="clip0">
        <rect width="24" height="24" transform="translate(18 18)" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
)

export default GiftRoundIcon
